import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { TimeDisplayEffects } from './store/time-display.effects';
import * as fromTimeDisplay from './store/time-display.reducers';
import { TimeDisplayService } from './time-display.service';
import { TimeDisplayComponent } from './time-display/time-display.component';

@NgModule({
    declarations: [TimeDisplayComponent],
    imports: [
        CommonModule,
        LoadingModule,
        StoreModule.forFeature(fromTimeDisplay.timeDisplayFeatureKey, fromTimeDisplay.timeDisplayReducer, {
            metaReducers: fromTimeDisplay.metaReducers
        }),
        EffectsModule.forFeature([TimeDisplayEffects])
    ],
    exports: [TimeDisplayComponent],
    providers: [TimeDisplayService]
})
export class TimeDisplayModule {}
